import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'adminSpecial'
})
export class AdminSpecialPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
